import React, { Component  } from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axios from 'axios';
import apiConfig from '../../apiConfig';


export default class navbar extends Component {

  
  constructor(props) {
    super(props);
    this.state = {
      basicInfoshow: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    this.basicInfoData();
  }

  basicInfoData = async () => {
    this.setState({ isLoading: true });
    try {
      //const response = await axios.get(`/api/commonData/basicinfo`);
      const response = await axios.get(`${apiConfig.baseURL}/api/commonData/basicinfo`);
      const newData = response.data;
      this.setState({
        basicInfoshow: newData,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };


  render() {
    const { basicInfoshow } = this.state;

    return (
      <>
        <div class="nav-header">
          <Link to="/admin" class="brand-logo">

            {/* <img src="assets/images/logo/success.png" class="logo-abbr" alt="" /> */}

             <img
               src={`/betwinzone.png`} 
              class="brand-title"
              alt=""
            />
            
          </Link>
         
        </div>
      </>
    );
  }
}
